import { render, staticRenderFns } from "./customer_detail.vue?vue&type=template&id=1422b9b6&scoped=true"
import script from "./customer_detail.vue?vue&type=script&lang=js"
export * from "./customer_detail.vue?vue&type=script&lang=js"
import style0 from "./customer_detail.vue?vue&type=style&index=0&id=1422b9b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422b9b6",
  null
  
)

export default component.exports